import { type ExternalLinkData } from '@terros/common'
import { isMaterialSymbol, SizePrimitives } from '@front/model'
import { MaterialSymbolIcon } from '../terros/icon/MaterialSymbolIcon'
import { type PageRoute } from '../navigation'

export const createLinkRoutes = (links: ExternalLinkData[]): PageRoute[] => {
  if (!links) return []

  return links.map((link) => ({
    path: toValidUrl(link.url),
    label: link.label,
    icon: isMaterialSymbol(link.icon) ? link.icon : 'link',
    isExternalLink: true,
    rightSection: <MaterialSymbolIcon icon='open_in_new' size={SizePrimitives['4']} />,
    section: 'Platform',
  }))
}

const toValidUrl = (url: string): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  return `http://${url}`
}
